import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router';
import { HelmetProvider } from 'react-helmet-async';
import { LandingPageProvider } from './context/LandingPageContext';
import { AuthProvider } from './context/AuthContext';
import LoadingSpinner from './components/LoadingSpinner';
import ErrorBoundary from './components/ErrorBoundary';
import ScrollToTop from "./components/ScrollToTop";
import ProtectedRoute from './components/ProtectedRoute';

// Lazy load pages
// const Home = React.lazy(() => import('./pages/Home'));
// const Blog = React.lazy(() => import('./pages/Blog'));
// const BlogPostDetail = React.lazy(() => import('./pages/BlogDynamicPage'));
const ShopPage = React.lazy(() => import('./pages/Shopt').then(module => ({ default: module.MainByAnima })));
const ProductListing = React.lazy(() => import('./pages/Productlisting'));
const ProductPage = React.lazy(() => import('./pages/ProductPage'));
const CheckoutPage = React.lazy(() => import('./pages/CheckoutPage'));
const ProductInfo = React.lazy(() => import('./pages/Product'));
const CartPage = React.lazy(() => import('./pages/CartPage'));
const NotFound = React.lazy(() => import('./pages/NotFound'));
const ShopLayout = React.lazy(() => import('./layouts/ShopLayout'));
const Authe = React.lazy(() => import('./pages/SignupinPage'));
const MyAccountPage = React.lazy(() => import('./pages/MyAccountPage'));
const OrderSuccessPage = React.lazy(() => import('./pages/OrderSuccessPage'));

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <LandingPageProvider>
          <Router>
            <ScrollToTop />
            <div className="App">
              <ErrorBoundary>
                <Suspense fallback={<LoadingSpinner />}>
                  <Routes>
                    {/* Main Routes - all render Home component with different scroll targets */}
                    {/* <Route path="/" element={<Home />} />
                    <Route path="/home" element={<Home scrollTo="home" />} />
                    <Route path="/about" element={<Home scrollTo="about" />} />
                    <Route path="/solutions" element={<Home scrollTo="solutions" />} />
                    <Route path="/funding" element={<Home scrollTo="funding" />} />
                    <Route path="/team" element={<Home scrollTo="ourTeam" />} />
                    <Route path="/tv" element={<Home scrollTo="tv" />} />
                    <Route path="/contact" element={<Home scrollTo="contact" />} />
                    
                    {/* Blog Routes 
                    <Route path="/blog" element={<Blog />} />
                    <Route path="/blog/:slug" element={<BlogPostDetail />} /> */}
                    
                    {/* Shop Routes (Now wrapped in ShopLayout to provide CartContext) */}
                    <Route element={<ShopLayout />}>
                      {/* Public auth route - redirect authenticated users */}
                      <Route 
                        path="/auth" 
                        element={
                          <ProtectedRoute requireAuth={false}>
                            <Authe />
                          </ProtectedRoute>
                        }
                      />
                      
                      {/* Public shopping routes */}
                      <Route path="/" element={<ShopPage />} />
                      <Route path="/products" element={<ProductListing />} />
                      <Route path="/products/:category" element={<ProductListing />} />
                      <Route path="/product/:id" element={<ProductInfo />} />
                      <Route path="/learnmore/:id" element={<ProductPage />} />
                      
                      {/* Protected routes - require authentication */}
                      <Route 
                        path="/my-account" 
                        element={
                          <ProtectedRoute requireAuth={true}>
                            <MyAccountPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route 
                        path="/checkout" 
                        element={
                          <ProtectedRoute requireAuth={true}>
                            <CheckoutPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route 
                        path="/cart" 
                        element={
                          <ProtectedRoute requireAuth={true}>
                            <CartPage />
                          </ProtectedRoute>
                        }
                      />
                      
                      {/* Order Success Route */}
                      <Route path="/order-success/:orderId" element={<OrderSuccessPage />} />
                      
                      {/* Legacy Routes */}
                      <Route path="/productlisting" element={<ProductListing />} />
                      <Route path="/productinfo" element={<ProductInfo />} />
                    </Route>
                    
                    {/* 404 Page */}
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </Suspense>
              </ErrorBoundary>
            </div>
          </Router>
        </LandingPageProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;